<template>
	<div>
		<div class="passwordReminderView">
			<v-app id="inspire">
				<v-content>
					<v-container fluid fill-height>
						<v-layout align-center justify-center>
							<v-flex class="password-reminder-view" xs12 sm8 md4>
								<v-card class="elevation-12">
									<v-flex dark color="primary" v-if="this.sent || this.error">
										<h3>Jeżeli konto o wskazanym adresie istnieje, e-mail z linkiem resetującym hasło został wysłany na Twoją skrzynkę pocztową.</h3>
									</v-flex>
									<v-spacer></v-spacer>
									<v-toolbar dark color="primary">
										<v-toolbar-title>Odzyskiwanie hasła</v-toolbar-title>
										<v-spacer></v-spacer>
										<v-btn
											icon
											large
											target="_blank"
											slot="activator"
										>
										</v-btn>
									</v-toolbar>
									<v-card-text>
										<v-text-field
											browser-autocomplete="off"
											prepend-icon="person"
											name="email"
											label="Email"
											aria-label="email"
											for="password-reminder-email"
											id="password-reminder-email"
											v-model="formData.email"
											type="text"></v-text-field>
									</v-card-text>
									<v-card-actions>
										<v-btn to="/change-bidder-email">Zmiana maila</v-btn>
										<v-spacer></v-spacer>
										<v-btn color="primary" @click="sendEmail">Resetuj hasło</v-btn>
									</v-card-actions>
								</v-card>
							</v-flex>
						</v-layout>
					</v-container>
				</v-content>
			</v-app>
		</div>
	</div>
</template>

<script>
	import {Api} from "@/api";

	export default {
		name: "PasswordReminderView",

		data() {
			return {
				formData: {
					email: "",
				},
				sent: false,
				error: false,
			};
		},

		methods: {
			sendEmail() {
				Api.post(this, "/credentials/send-password-setup-email", this.formData, response => {
					if (response.status === "OK") {
						this.sent = true;
					} else {
						this.error = true;
					}
				});
			},
		},
	};
</script>

<style scoped>

</style>
